module.exports = __webpack_public_path__ + "static/img/7.11f292a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/7.png
// module id = jS7x
// module chunks = 0